import React from 'react';
import moment from 'moment';
import { navigate } from 'gatsby';
import { toast, Slide } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';
import Toast from '../../common/components/Toast/Toast';
import {
  removeApplicantionInfo,
  setApplicantionInfo
} from '../../common/utils/applicantionInfo';
export const numberFormat = number => {
  if (!isNaN(number) && number) {
    let num;
    try {
      num = number
        .toFixed(1)
        .replace(/(\d)(?=(\d{2})+\d\.)/g, '$1,')
        .toString()
        .split('.')[0];
    } catch {
      num = number;
    }
    return num;
  }
  return number;
};
export const DateFormat = date => {
  if (date && moment(date).isValid()) {
    return moment(date).format('DD-MM-YYYY');
  }
  return date;
};
const handleRowClick = row => {
  if (row.status == 'Follow Up' || row.status == 'Not Interested') {
    navigate(`/app/addlead?leadId=${row.leadId}`);
  } else {
    let applicationInfo = {
      leadId: row.leadId,
      leadApplicantId: row.applicantId,
      applicationStatus: row.status
    };
    removeApplicantionInfo();
    setApplicantionInfo(applicationInfo);
    let leadProductInfo = {
      leadProduct: row?.product,
      leadSubProduct: row?.subProduct
    };
    localStorage.setItem('leadProductInfo', JSON.stringify(leadProductInfo));

    navigate(`/app/leadprofile`);
  }
};

const commonStyle = 'text-xs maindashbord text-center mx-auto';
const commonHeaderStyle = 'text-center mx-auto';

const Columns = [
  {
    name: <span className={`${commonHeaderStyle}`}>Priority</span>,
    selector: 'priority',
    sortable: true,
    cell: row => (
      <div className="flex items-center">
        {row.priority == 'High' ? (
          <p
            className="text-red-100"
            style={{ fontWeight: '900', fontSize: '19px' }}
          >
            &#8593;
          </p>
        ) : row.priority == 'Low' ? (
          <p
            className="text-green-500"
            style={{ fontWeight: '900', fontSize: '19px' }}
          >
            &#8595;
          </p>
        ) : row.priority == 'Medium' ? (
          <p
            className="text-orange-200"
            style={{ fontWeight: '900', fontSize: '19px' }}
          >
            &#8593;
          </p>
        ) : null}
        <span className="mx-2">{row.priority}</span>
      </div>
    )
  },
  {
    name: <span className={`${commonHeaderStyle}`}>Customer Name</span>,
    selector: 'name',
    sortable: true,
    cell: row => {
      let firstName = '',
        middleName = '',
        lastName = '';
      if (row.name.firstName) {
        firstName = row.name.firstName.toString() + ' ';
      }
      if (row.name.middleName) {
        middleName = row.name.middleName.toString() + ' ';
      }
      if (row.name.firstName) {
        lastName = row.name.lastName.toString();
      }
      return (
        <div className="w-full mx-auto text-center">
          <p
            className={`text-center whitespace-pre ${commonStyle}`}
            style={{ whiteSpace: 'break-spaces' }}
          >
            {firstName + middleName + lastName}
          </p>
        </div>
      );
    },
    minWidth: '70px !important'
  },
  {
    name: <span className={`${commonHeaderStyle}`}>Lead ID</span>,
    selector: 'leadId',
    sortable: true,
    cell: row => (
      <div className="w-full mx-auto text-center">
        <p
          className={`text-center whitespace-pre ${commonStyle}`}
          style={{ whiteSpace: 'break-spaces' }}
        >
          {row.leadId}
        </p>
      </div>
    )
  },
  {
    name: <span className={`${commonHeaderStyle}`}>Sourcing Date</span>,
    selector: 'sourcingDate',
    sortable: true,
    cell: row => (
      <div className="w-full mx-auto text-center">
        <p
          className={`text-center whitespace-pre ${commonStyle}`}
          style={{ whiteSpace: 'break-spaces' }}
        >
          {DateFormat(row.sourcingDate)}
        </p>
      </div>
    ),
    minWidth: '70px !important'
  },
  {
    name: <span className={`${commonHeaderStyle}`}>Status</span>,
    selector: 'status',
    sortable: true,
    cell: row => {
      let styleContainer, classcontainer;
      if (
        row.status == 'New Lead' ||
        row.status == 'closed' ||
        row.status == 'Sanctioned'
      ) {
        classcontainer =
          'text-green-600 items-center py-1  px-1 rounded font-roboto font-sm mx-auto';
        styleContainer = { backgroundColor: '#a1f5a8' };
      } else if (row.status == 'Doc Pending') {
        classcontainer =
          'text-orange-600 items-center py-1  px-2 rounded font-roboto font-xs mx-auto';
        styleContainer = { backgroundColor: '#ffdec1', fontSize: '11px' };
      } else if (row.status == 'Login') {
        classcontainer =
          'text-orange-600 items-center py-1  px-2 rounded font-roboto font-xs mx-auto';
        styleContainer = { backgroundColor: '#fff1e5', fontSize: '11px' };
      } else if (row.status == 'Follow Up') {
        classcontainer =
          'text-blue-500 items-center py-1  px-2 rounded font-roboto font-xs mx-auto';
        styleContainer = { backgroundColor: '#aebae4', fontSize: '11px' };
      } else if (row.status == 'Not Interested') {
        classcontainer =
          'text-red-100 items-center py-1  px-2 rounded font-roboto font-xs mx-auto';
        styleContainer = { backgroundColor: '#ffdec1', fontSize: '11px' };
      } else if (row.status == 'BP Raised') {
        classcontainer =
          'text-blue-500 items-center py-1  px-2 rounded font-roboto font-xs mx-auto';
        styleContainer = { backgroundColor: '#aebae4' };
      } else if (row.status == 'Disbursed') {
        classcontainer =
          'text-blue-500 items-center py-1  px-2 rounded font-roboto font-xs mx-auto';
        styleContainer = { backgroundColor: '#aebae4' };
      } else if (row.status == 'In Principle Pending') {
        classcontainer =
          'text-red-100 items-center py-1  px-2 rounded font-roboto font-xs mx-auto';
        styleContainer = { backgroundColor: '#f7e5e7' };
      } else if (row.status == 'In Principle Accepted') {
        classcontainer =
          'text-white items-center py-1  px-2 rounded font-roboto font-xs mx-auto';
        styleContainer = { backgroundColor: '#00ACB8' };
      }
      let a = document.getElementsByClassName('status');
      return (
        <div
          className="flex items-center cursor-pointer"
          onClick={() => handleRowClick(row)}
        >
          <div className={classcontainer + ' status'} style={styleContainer}>
            <p
              className={`${commonStyle}`}
              style={{ whiteSpace: 'break-spaces' }}
            >
              {row.status == 'New Lead' ? 'Lead' : row.status}
            </p>
          </div>
        </div>
      );
    },
    minWidth: '80px !important'
  },
  {
    name: <span className={`${commonHeaderStyle}`}>Product</span>,
    selector: 'product',
    sortable: true,
    cell: row => (
      <div className="w-full mx-auto text-center">
        <p
          className={`text-center whitespace-pre ${commonStyle}`}
          style={{ whiteSpace: 'break-spaces' }}
        >
          {row.product ? row.product : <span>&#8212; </span>}
        </p>
      </div>
    )
  },
  {
    name: <span className={`${commonHeaderStyle}`}>Sub Product</span>,
    selector: 'subProduct',
    sortable: true,
    cell: row => (
      <div className="w-full mx-auto text-center">
        <p
          className={`text-center whitespace-pre ${commonStyle}`}
          style={{ whiteSpace: 'break-spaces' }}
        >
          {row.subProduct ? row.subProduct : <span>&#8212; </span>}
        </p>
      </div>
    )
  },
  {
    name: <span className={`${commonHeaderStyle}`}>City</span>,
    selector: 'city',
    sortable: true,
    cell: row => (
      <div className="w-full mx-auto text-center">
        <p
          className={`text-center whitespace-pre ${commonStyle}`}
          style={{ whiteSpace: 'break-spaces' }}
        >
          {row.city ? row.city : <span>&#8212; </span>}
        </p>
      </div>
    )
  },

  {
    name: <span className={`${commonHeaderStyle}`}>Loan Amount</span>,
    selector: 'loanAmount',

    sortable: true,
    cell: row => (
      <div className="w-full mx-auto ">
        <p
          className={` whitespace-pre ${commonStyle}`}
          style={{ whiteSpace: 'break-spaces' }}
        >
          &#8377;{numberFormat(row.loanAmount ? row.loanAmount : 0)}
        </p>
      </div>
    ),
    minWidth: '70px !important'
  },
  {
    name: <span className={`${commonHeaderStyle}`}>Login Amount</span>,
    selector: 'loginAmount',

    sortable: true,
    cell: row => (
      <div className="w-full mx-auto ">
        <p
          className={` whitespace-pre ${commonStyle}`}
          style={{ whiteSpace: 'break-spaces' }}
        >
          &#8377;{numberFormat(row?.loginAmount ? row?.loginAmount : '0')}
        </p>
      </div>
    ),
    minWidth: '70px !important'
  },

  {
    name: <span className={`${commonHeaderStyle}`}>Login Date</span>,
    selector: 'loginDate',

    sortable: true,
    cell: row => (
      <div className="w-full mx-auto ">
        <p
          className={` whitespace-pre ${commonStyle}`}
          style={{ whiteSpace: 'break-spaces' }}
        >
          {row?.loginDate ? DateFormat(row?.loginDate) : 'NA'}
        </p>
      </div>
    ),
    minWidth: '70px !important'
  },
  {
    name: <span className={`${commonHeaderStyle}`}>Sanction Amount</span>,
    selector: 'finalSanctionAmount',

    sortable: true,
    cell: row => (
      <div className="w-full mx-auto ">
        <p
          className={` whitespace-pre ${commonStyle}`}
          style={{ whiteSpace: 'break-spaces' }}
        >
          &#8377;
          {numberFormat(
            row?.finalSanctionAmount ? row?.finalSanctionAmount : 0
          )}
        </p>
      </div>
    ),
    minWidth: '70px !important'
  },
  {
    name: <span className={`${commonHeaderStyle}`}>Sanction Date</span>,
    selector: 'finalSanctionDate',

    sortable: true,
    cell: row => (
      <div className="w-full mx-auto ">
        <p
          className={` whitespace-pre ${commonStyle}`}
          style={{ whiteSpace: 'break-spaces' }}
        >
          {row?.finalSanctionDate ? DateFormat(row?.finalSanctionDate) : 'NA'}
        </p>
      </div>
    ),
    minWidth: '70px !important'
  },
  {
    name: <span className={`${commonHeaderStyle}`}>Disbursed Amount</span>,
    selector: 'disbursedAmount',
    sortable: true,
    cell: row => (
      <div className="w-full mx-auto text-center">
        <p
          className={`text-center whitespace-pre ${commonStyle}`}
          style={{ whiteSpace: 'break-spaces' }}
        >
          &#8377; &nbsp;
          {numberFormat(row.disbursedAmount ? row.disbursedAmount : 0)}
        </p>
      </div>
    ),
    minWidth: '70px !important'
  },
  {
    name: <span className={`${commonHeaderStyle}`}>Disbursed Date</span>,
    selector: 'disbursedtDate',

    sortable: true,
    cell: row => (
      <div className="w-full mx-auto ">
        <p
          className={` whitespace-pre ${commonStyle}`}
          style={{ whiteSpace: 'break-spaces' }}
        >
          {row?.disbursedDate ? DateFormat(row?.disbursedDate) : 'NA'}
        </p>
      </div>
    ),
    minWidth: '70px !important'
  },
  {
    name: <span className={`${commonHeaderStyle}`}>Bank</span>,
    selector: 'bankName',
    sortable: true,
    cell: row => (
      <div className="w-full mx-auto text-center">
        <p
          className={`text-center whitespace-pre ${commonStyle}`}
          style={{ whiteSpace: 'break-spaces' }}
        >
          {row.bankName ? row.bankName : <span>&#8212; </span>}
        </p>
      </div>
    )
  },
  {
    name: <span className={`${commonHeaderStyle}`}>Payout</span>,
    selector: 'payout',
    sortable: true,
    cell: row => (
      <div className="w-full mx-auto text-center">
        <p
          className={`text-center whitespace-pre ${commonStyle}`}
          style={{ whiteSpace: 'break-spaces' }}
        >
          {' '}
          &#8377; &nbsp;{numberFormat(row.payout ? row.payout : 0)}
        </p>
      </div>
    )
  },
  {
    name: <span className={`${commonHeaderStyle}`}>DOC Pending</span>,
    selector: 'doc_pending',
    sortable: true,
    cell: row => {
      return (
        <div
          className={`text-red-400 px-3 py-1  mx-auto ${commonStyle}`}
          style={{ backgroundColor: '#F7E5E7', borderRadius: '7px' }}
        >
          {row.doc_pending ? row.doc_pending : 0}
        </div>
      );
    }
  },
  {
    name: <span className={`${commonHeaderStyle}`}>Last Action Date</span>,
    selector: 'lastActionDate',
    sortable: true,
    cell: row => (
      <div className="w-full mx-auto text-center">
        <p
          className={`text-center whitespace-pre ${commonStyle}`}
          style={{ whiteSpace: 'break-spaces' }}
        >
          {DateFormat(row.lastActionDate)}
        </p>
      </div>
    ),
    minWidth: '70px !important'
  }
];

export default Columns;
